import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

import { Auth as AuthComponent } from './auth-component';
import { loader as authLoader } from './auth-loader';
import { Login } from './login';

export const AuthRoutes: RouteObject[] = [
  {
    loader: authLoader,
    element: <AuthComponent />,
    children: [
      { path: ROUTES_PATH.login, element: <Login /> },
      {
        path: 'password-registration',
        children: [
          { index: true, lazy: () => import('./password-registration') },
          {
            path: 'success',
            lazy: () => import('./password-registration-success'),
          },
          {
            path: 'error',
            lazy: () => import('./password-registration-error'),
          },
          {
            path: 'expired-error',
            lazy: () => import('./password-registration-expired-error'),
          },
          {
            path: 'email-error',
            lazy: () => import('./password-registration-email-error'),
          },
        ],
      },
      {
        path: 'password-reset',
        children: [
          { path: 'new-password', lazy: () => import('./password-reset') },
          { path: 'success', lazy: () => import('./password-reset-success') },
          { path: 'error', lazy: () => import('./password-reset-error') },
          {
            path: 'expired-error',
            lazy: () => import('./password-reset-expired-error'),
          },
          {
            path: 'send-email',
            lazy: () => import('./password-reset-send-email'),
          },
          {
            path: 'send-email-success',
            lazy: () => import('./password-reset-send-email-success'),
          },
        ],
      },
    ],
  },
];
